import { render } from "./interactiveGuidanceView.vue?vue&type=template&id=2811b4bd&scoped=true&ts=true"
import script from "./interactiveGuidanceView.vue?vue&type=script&lang=ts"
export * from "./interactiveGuidanceView.vue?vue&type=script&lang=ts"

import "./interactiveGuidanceView.vue?vue&type=style&index=0&id=2811b4bd&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2811b4bd"]])

export default __exports__